import { render, staticRenderFns } from "./walletWithdrawalApply.vue?vue&type=template&id=a8ffe580&scoped=true&"
import script from "./walletWithdrawalApply.vue?vue&type=script&lang=js&"
export * from "./walletWithdrawalApply.vue?vue&type=script&lang=js&"
import style0 from "./walletWithdrawalApply.vue?vue&type=style&index=0&id=a8ffe580&scoped=true&lang=css&"
import style1 from "./walletWithdrawalApply.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ffe580",
  null
  
)

export default component.exports